import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import ActionModal from './ActionModal';
import UserAvatar from './UserAvatar';
import EduOpsLogo from './EduOpsLogo';

export default function Header({ toggleSidebar }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <header className="h-20 glass-panel border-b border-x-0 border-t-0 px-4 md:px-8 flex items-center justify-between sticky top-0 z-30">
        
        <div className="flex items-center gap-4">
          <button 
            onClick={toggleSidebar}
            className="lg:hidden p-2 text-slate-400 hover:text-white rounded-lg hover:bg-slate-800 focus:outline-none"
          >
            <SafeIcon icon="FiMenu" className="text-2xl" />
          </button>
          
          <div className="lg:hidden flex items-center gap-2">
            <EduOpsLogo size="sm" />
            <span className="text-lg font-bold text-chalk">Edu<span className="text-principal">Ops</span></span>
          </div>
          
          <div className="hidden md:flex items-center glass-panel bg-slate-950/40 rounded-full px-4 py-2 w-64 lg:w-96 border border-slate-800/50 focus-within:border-blue-500/50 transition-all duration-300">
            <SafeIcon icon="FiSearch" className="text-slate-500 text-lg mr-3" />
            <input 
              type="text" 
              placeholder="Search students, classes, or staff..." 
              className="bg-transparent border-none outline-none text-sm w-full text-slate-200 placeholder-slate-600 font-sans"
            />
            <div className="flex gap-1 items-center">
              <kbd className="hidden lg:inline-flex px-1.5 py-0.5 text-[9px] font-mono bg-slate-800 text-slate-500 rounded border border-slate-700 uppercase">Cmd</kbd>
              <kbd className="hidden lg:inline-flex px-1.5 py-0.5 text-[9px] font-mono bg-slate-800 text-slate-500 rounded border border-slate-700">K</kbd>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-3 md:gap-6">
          <button 
            onClick={() => setIsModalOpen(true)}
            className="hidden sm:flex items-center gap-2 bg-principal text-white px-4 py-2 rounded-xl text-xs font-bold uppercase tracking-wider shadow-lg shadow-blue-500/20 hover:shadow-blue-500/40 transition-all"
          >
            <SafeIcon icon="FiZap" className="text-sm" />
            <span>Quick Action</span>
          </button>

          <div className="flex items-center gap-3 border-l border-slate-800 pl-3 md:pl-6">
            <button className="relative p-2 text-slate-400 hover:text-white transition-colors group">
              <SafeIcon icon="FiBell" className="text-xl" />
              <span className="absolute top-2 right-2 w-2 h-2 bg-bell rounded-full border-2 border-slate-950 shadow-[0_0_8px_rgba(249,115,22,0.6)]"></span>
            </button>
            
            <div className="cursor-pointer group">
              <UserAvatar 
                name="Arthur Miller" 
                role="Principal" 
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150&h=150&q=80" 
              />
            </div>
          </div>
        </div>
      </header>

      <ActionModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}